<div class="text-danger"
     style="visibility: hidden;"
     [ngClass]="{'visible': control && control.errors && (control.dirty || control.touched)}">
        <div *ngIf="!control.errors"><small>no error</small></div>
        <div *ngIf="control.errors && control.errors.required"><small>Enter {{label??'Field'}}</small></div>
        <span *ngIf="control.errors && control.errors.email"><small>Enter a valid email</small></span>
        <div *ngIf="control.errors && control.errors.phoneNumber"><small>Enter a valid phone number</small></div>
        <div *ngIf="control.errors && control.errors.confirmedValidator"><small>Password does not match</small></div>
        <div *ngIf="control.errors && control.errors.pattern"><small>Invalid {{label??'value'}}</small></div>
        <div *ngIf="control.errors && control.errors.invalidPassword"><small>Password should have minimum 6 characters,
                        at
                        least one letter, one number, and one special character and shouldn't contain space.</small>
        </div>
</div>